import { createMuiTheme } from '@material-ui/core'
import fonts from 'styles/fonts.css'

const theme = createMuiTheme({
  palette: {
    common: {
      gold: '#f2a900',
      orange: '#f26449',
      magenta: '#c52c7c',
      green: {
        light: '#8fc73e',
        dark: '#00af78',
      },
      blue: {
        light: '#00b8c4',
        dark: '#3b66b0',
      },
    },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    text: {
      primary: '#414042',
      secondary: '#414042',
      body: '#414042',
      header: '#53565a',
    },
  },
  typography: {
    fontFamily: ['LL Replica Pro Sub Light'].join(','),
    header: ['Utopia Standard'].join(','),
  },
  overrides: {
    MuiAccordion: {
      root: {
        '&$expanded': {
          marginTop: 0,
          '&:before': {
            opacity: 100,
          },
        },
      },
    },
    MuiLink: {
      root: {
        color: '#3b66b0',
      },
      underlineHover: {
        textDecoration: 'underline',
      },
    },
  },
})

export default theme
